import { HashLink } from 'react-router-hash-link';


function PEM() {
  return (
     <div className="bg-projects2 absolute top-0 left-0 min-h-screen w-full bg-gray-100 flex flex-col items-center justify-start px-4 sm:px-8 scroll-mt-[80px] -mt-[80px]">
      
      <div className="w-full max-w-4xl mx-auto pt-2">
        <HashLink
            smooth
            to="/#resume-prof-projects"
            className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
        >
            <span className="mr-1">←</span> Go back to Home
        </HashLink>
      </div>
      
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-6 sm:p-10 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-bold title-color">Problem Exposure Management (PEM)</h1>
        <p className="text-md text-gray-500 italic">Client: Top-tier global bank | Duration: Mar 2022 – Feb 2024</p>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Overview</h2>
          <p className="text-gray-700 mb-2">
            Spearheaded the development and standardization of regional data assets to support consistent capture and reporting of post-default loss and recovery data across multiple sites. The initiative enhanced compliance with regulatory protocols and enabled the calculation of realized LGD and conversion factors at a global level. A centralized solution was designed using the upgraded CPM tool to support advanced model monitoring and development.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li><strong>Role:</strong> Lead Data Analyst</li>
            <li>Collaborated with stakeholders to design scalable data architecture and ER diagrams.</li>
            <li>Guided raw data ingestion efforts to ensure consistency across platforms.</li>
            <li>Engineered data pipelines in PySpark to build and maintain clean Parquet datasets in HDFS.</li>
            <li>Led a team of 3 data analysts to deliver critical components on time.</li>
            <li>Performed impact analysis and applied enhancements per regulatory updates.</li>
            <li>Performance & Stakeholder Impact: Serving 3 dashboards to stakeholders with &lt;1 second latency.</li>
            <li>Worked with data engineering and platform teams for production deployment and adoption.</li>
            <li>Developed automated Jenkins pipelines to deploy PySpark jobs and Parquet datasets into Hadoop clusters across regions.</li>
            <li>Designed and managed Airflow DAGs to automate complex data workflows, ensuring reliable and timely pipeline execution with minimal manual intervention.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Key Responsibilities</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              <strong>Centralized Data Capture:</strong> Enabled consistent and compliant post-default loss/recovery data collection across regions, supporting accurate LGD calculations and global model metrics.
            </li>
            <li>
              <strong>Enhanced Decision-Making & Monitoring:</strong> Improved data accessibility through API-powered UI tools and dashboards. Supported model monitoring, validation, and development with write-back and refinery integration.
            </li>
            <li>
              <strong>Unified Reporting Framework:</strong> Consolidated regional data into a single authoritative source for enterprise-wide reporting and insights.
            </li>
          </ul>
        </section>

      </div>
    </div>
  );
}

export default PEM;

